import { deleteStoreAlert, addAlert, setStoreAlert } from 'modules/alert';
import { put, delay, takeEvery, take, call, fork } from 'redux-saga/effects';
import { nanoid } from 'nanoid/non-secure';
import { getType } from 'deox';
import { ALERT_LIVING_TIME } from 'constants/alert';
import { createAxiosInterceptorChannel } from 'utils/apiWrapper';
import { WEBSITE_URL } from 'utils/env';
import { errorMessages, errorUnknownMessage } from '../../constants/errorMessages';
import { EventChannel } from '@redux-saga/core';
import { AxiosResponse } from 'axios';
import ErrorLogger from '../../components/ErrorLogger';

export function* addAlertSaga({ payload }: ReturnType<typeof addAlert>) {
  const id = nanoid();
  yield put(setStoreAlert({ id, ...payload }));

  if (!payload.isModal) {
    yield delay(ALERT_LIVING_TIME);
    yield put(deleteStoreAlert(id));
  }
}

function* axiosInterceptorSaga() {
  const axiosInterceptor: EventChannel<AxiosResponse> = yield call(createAxiosInterceptorChannel);
  while (true) {
    try {
      const {
        payload: { url, status }
      } = yield take(axiosInterceptor);

      if (status === 401) {
        window.location.href = `${WEBSITE_URL}/logout`;
        return;
      }
      // eslint-disable-next-line
      console.error('url:', url, 'status:', status);
      // prevent alert  when request shutterstock content size
      if (status === 405 && url.includes('shutterstock')) {
        return;
      }
      if (status in errorMessages) {
        yield put(addAlert(...errorMessages[status]));
      } else {
        yield put(addAlert(errorUnknownMessage.title, errorUnknownMessage.errorUnknown));
      }
    } catch (error) {
      ErrorLogger.trigger(error);
      // eslint-disable-next-line
      console.error(error);
      yield put(addAlert(errorUnknownMessage.title, errorUnknownMessage.errorUnknown));
    }
  }
}

export default function* alertSaga() {
  yield fork(axiosInterceptorSaga);
  yield takeEvery(getType(addAlert), addAlertSaga);
}
